import React, { Fragment, useEffect } from 'react';
import { ModalDialog } from '@uhg-abyss/web/ui/ModalDialog';
import PropTypes from 'prop-types';
import { Button } from '@uhg-abyss/web/ui/Button';
import { styled } from '@uhg-abyss/web/tools/styled';
import { useSelector } from 'react-redux';
import { useDeleteFile } from '@src/hooks/useDeleteFile';
import { useDeleteCommunicationAPI } from '@src/hooks/useDeleteCommunicationAPI';
import { useGetCommunicationAPI } from '@src/hooks/useGetCommunicationAPI';

const ButtonConatiner = styled('div', {
  display: 'flex',
  justifyContent: 'flex-end',
  marginBottom: '15px',
});

export const DeleteSelectedDraftsModal = ({
  showModal,
  modalOnClose,
  ids = [],
}) => {
  const [deleteCommunication, deleteCommunicationAPI] =
    useDeleteCommunicationAPI();
  const [communicationAPI] = useGetCommunicationAPI();
  const [deleteFiles, deleteUploadedFiles] = useDeleteFile();
  const userInfo = useSelector((state) => {
    return state.GET_USER_INFO.data;
  });

  useEffect(() => {
    if (
      !deleteFiles.loading &&
      deleteFiles.data.message &&
      !deleteFiles.error
    ) {
      modalOnClose(false);
    }
  }, [deleteFiles]);

  useEffect(() => {
    if (
      !deleteCommunication.loading &&
      deleteCommunication.data.message &&
      !deleteCommunication.error
    ) {
      const { draftMessages = [] } = communicationAPI.data || {};
      const deleteFileIds = draftMessages.reduce((accumulator, draft) => {
        if (ids?.includes(draft.id) && draft?.fileIds?.length) {
          return [
            ...accumulator,
            ...(Array.isArray(draft?.fileIds) ? draft.fileIds : []),
          ];
        }
        return accumulator;
      }, []);

      if (deleteFileIds?.length) {
        const fileKeyList = deleteFileIds?.map((fileId) => {
          return {
            Key: `apimarketplace/${fileId}`,
          };
        });
        deleteUploadedFiles({ userInfo, fileKeyList });
      } else {
        modalOnClose(false);
      }
    } else {
      // TODO: handle errror scenario
    }
  }, [deleteCommunication]);

  const onClick = () => {
    deleteCommunicationAPI({ userInfo, ids });
  };

  return (
    <Fragment>
      <ModalDialog
        header="Selected draft communications will be permanently deleted."
        isOpen={showModal}
        onClose={modalOnClose}
        size="md"
        css={{
          'abyss-modal-base-header-container': {
            color: '#002677',

            width: '100%',
          },
          'abyss-modal-base-header': {
            fontFamily: 'AbyssUHCSerif !important',
            fontSize: '26px !important',
            padding: '8px 16px',
          },
        }}
      >
        <ButtonConatiner>
          <Button
            id="cancelButton"
            size="$md"
            variant="outline"
            fontSize="15px"
            onClick={() => {
              return modalOnClose(false);
            }}
            style={{ marginRight: '10px' }}
          >
            Cancel
          </Button>
          <Button
            size="$md"
            fontSize="15px"
            onClick={onClick}
            id="continueButton"
            isLoading={deleteCommunication.loading}
            ariaLoadingLabel="Delete Draft"
          >
            Continue
          </Button>
        </ButtonConatiner>
      </ModalDialog>
    </Fragment>
  );
};
DeleteSelectedDraftsModal.propTypes = {
  modalOnClose: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
  ids: PropTypes.arrayOf(PropTypes.string).isRequired,
};
